import React from 'react';
import PropTypes from 'prop-types';
import BrandingBar from 'apps/new-web/views/components/branding-bar';
import DesktopReviews from './desktop-reviews';
import MobileReviews from './mobile-reviews';
import I18n from 'apps/new-web/views/components/i18n';

const CorporateReviews = ({ mediaType, noAlts, reviewsMobile, reviewsDesktop, includeBrandingBar }) => {
  return (
    <section
      className="corporate-reviews-component"
      aria-label={ I18n.translate('[ifit] Reviews', { ifit: 'iFit' }, 'Title introducing periodical reviews about the iFit app.') }
    >
      { mediaType === 'mobile' ? (
        <div>
          { includeBrandingBar && (
            <BrandingBar />)
          }
          <MobileReviews reviews={ reviewsMobile } noAlts={ noAlts } />
        </div>
      ) : (
        <DesktopReviews reviews={ reviewsDesktop } noAlts={ noAlts } />
      )}
    </section>
  );
};

CorporateReviews.propTypes = {
  mediaType: PropTypes.string.isRequired,
  noAlts: PropTypes.bool,
  reviewsMobile: PropTypes.array.isRequired,
  reviewsDesktop: PropTypes.array.isRequired,
  includeBrandingBar: PropTypes.bool
};

CorporateReviews.defaultProps = {
  includeBrandingBar: true
};

export default CorporateReviews;
